import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["indentation", "use", "children"];
import styled from 'foundations-theming/utils';
import { toPx } from '../../../utils/toPx';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { PADDING } from '../../../constants/nonTokenisedValues';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledExpandableContents = styled.div.withConfig({
  displayName: "ExpandableContents__StyledExpandableContents",
  componentId: "sc-6cqmyj-0"
})(({
  $indentation = 'default',
  $use,
  theme,
  $cssStyles
}) => {
  const INDENT_OPTIONS = {
    default: PADDING.EXPANDABLE_CONTENTS_PADDING_INLINE_DEFAULT,
    compact: theme.space['500'],
    none: theme.space['0']
  };
  return Object.assign({
    paddingBlockEnd: theme.space['600'],
    paddingInlineStart: typeof $indentation === 'number' ? toPx($indentation) : INDENT_OPTIONS[$indentation],
    paddingInlineEnd: $indentation === 'none' ? theme.space['0'] : theme.space['500'],
    paddingBlockStart: $indentation === 'none' ? theme.space['0'] : $use === 'enclosed' ? theme.space['500'] : theme.space['100']
  }, $cssStyles, {
    '> :last-child': {
      marginBlockEnd: theme.space['0']
    }
  });
});
export const ExpandableContents = _ref => {
  let {
      indentation = 'default',
      use,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledExpandableContents, Object.assign({
    $use: use,
    $indentation: indentation,
    $cssStyles: cssStyles
  }, domProps, {
    children: children
  }));
};
ExpandableContents.displayName = 'ExpandableContents';